import { useState } from 'react';

/**
 * Hook personalizado para gestionar listas dinámicas (Hipervínculos/Contactos)
 */
export const useListaDinamica = () => {
    const [items, setItems] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [itemEdicion, setItemEdicion] = useState(null);
    const [formItem, setFormItem] = useState({
        orden: 1,
        titulo: '',
        contenido: '',
        hipervinculo: '',
        imagen: null,
        activo: true
    });

    const agregarItem = () => {
        setItemEdicion(null);
        setFormItem({
            orden: items.length + 1,
            titulo: '',
            contenido: '',
            hipervinculo: '',
            imagen: null,
            activo: true
        });
        setDialogVisible(true);
    };

    const editarItem = (index) => {
        setItemEdicion(index);
        setFormItem(items[index]);
        setDialogVisible(true);
    };

    const guardarItem = () => {
        if (itemEdicion !== null) {
            const nuevosItems = [...items];
            nuevosItems[itemEdicion] = formItem;
            setItems(nuevosItems);
        } else {
            setItems([...items, formItem]);
        }
        setDialogVisible(false);
    };

    const eliminarItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };

    const moverItem = (index, direccion) => {
        const nuevosItems = [...items];
        const temp = nuevosItems[index];
        if (direccion === 'arriba' && index > 0) {
            nuevosItems[index] = nuevosItems[index - 1];
            nuevosItems[index - 1] = temp;
        } else if (direccion === 'abajo' && index < items.length - 1) {
            nuevosItems[index] = nuevosItems[index + 1];
            nuevosItems[index + 1] = temp;
        }
        setItems(nuevosItems);
    };

    const resetItems = () => {
        setItems([]);
    };

    return {
        items,
        setItems,
        dialogVisible,
        setDialogVisible,
        itemEdicion,
        setItemEdicion,
        formItem,
        setFormItem,
        agregarItem,
        editarItem,
        guardarItem,
        eliminarItem,
        moverItem,
        resetItems
    };
};
